import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from '../routes/routes';
import ProtectedRoute from './ProtectedRoute';
import Login from '../components/Login/Login';
import InvestigationDetail from '../components/Investigation/InvestigationDetail';
import InvestigationsList from '../components/Investigation/InvestigationsList';
import Setting from '../components/Settings/Settings';
import TeamDetail from '../components/Team/TeamDetail';
import ChatRoom from '../components/ChatRoom/ChatRoom';
import Gallery from '../components/Gallery';
import SignUp from '../components/SignUp/SignUp';
import TaskList from '../components/Task/TaskList';
import TaskDetail from '../components/Task/TaskDetail';
import ResponseDetail from '../components/Response/ResponseDetail';
import { SignUpRoute } from './SignUpRoute';
import ExpertList from '../components/Expert/ExpertList';
import ExpertDetail from '../components/Expert/UserDetail';
import TeamsList from '../components/Team/TeamsList';
import CreateInvestigation from '../components/Investigation/CreateInvestigation';

export const Pages = () => {
	return (
		<>
			<Switch>
				<ProtectedRoute exact path='/' component={InvestigationsList} />
				<SignUpRoute exact path='/SignUp' component={SignUp} />
				<SignUpRoute exact path='/Login' component={Login} />

				<ProtectedRoute
					exact
					path='/Dashboard'
					component={InvestigationsList}
				/>

				<ProtectedRoute
					exact
					path='/Investigations'
					component={InvestigationsList}
				/>
				<ProtectedRoute
					exact
					path='/Investigations/details/:id'
					component={InvestigationDetail}
				/>
				<ProtectedRoute
					exact
					path='/Investigations/new'
					component={CreateInvestigation}
				/>

				<ProtectedRoute exact path='/Tasks' component={TaskList} />
				<ProtectedRoute
					exact
					path='/Tasks/details/:taskId'
					component={TaskDetail}
				/>

				<ProtectedRoute
					exact
					path='/Responses/details/:responseId'
					component={ResponseDetail}
				/>

				<ProtectedRoute exact path='/Teams' component={TeamsList} />
				<ProtectedRoute
					exact
					path='/Teams/details/:id'
					component={TeamDetail}
				/>

				<ProtectedRoute exact path='/Experts' component={ExpertList} />
				<ProtectedRoute
					exact
					path='/Experts/details/:id'
					component={ExpertDetail}
				/>
				<Route exact path='/Chat' component={ChatRoom} />
				<Route exact path='/Gallery' component={Gallery} />
				<Route component={NotFound} />
			</Switch>
		</>
	);
};
